import initialState from '../store/initial-state'
import {
  PERMISSION_SHOW,
  PERMISSION_HIDE,
  SET_ITEM,
  GET_ITEM,
  GET_ITEM_SUCCESS,
  GET_ITEM_FAILURE,
  MYPERMISSION_REQUETS,
  MYPERMISSION_REQUETS_SUCCESS,
  MYPERMISSION_REQUETS_FAILURE,
  GIVING_PERMISSION,
  SET_IS_FETCHING_OBJECT_GROUPS,
  UNSET_IS_FETCHING_OBJECT_GROUPS,
  PERMISSION_HIDE_MODAL,
  PERMISSION_SHOW_MODAL,
  UNSET_IS_FETCHING_OBJECT_GROUPS_MODAL,
  SET_IS_FETCHING_OBJECT_GROUPS_MODAL
} from '../constants/permission-types'

export default (state = initialState.permission, action) => {
  switch (action.type) {
    case PERMISSION_SHOW:
      return {
        ...state,
        item: action.payload.item,
        show: action.payload.show
      }
    case PERMISSION_SHOW_MODAL:
      return {
        ...state,
        item: action.payload.item,
        showModal: action.payload.showModal
      }
    case PERMISSION_HIDE: {
      return {
        ...state,
        // item: {},
        show: false
      }
    }
    case PERMISSION_HIDE_MODAL: {
      return {
        ...state,
        // item: {},
        showModal: false
      }
    }
    case SET_ITEM: {
      return {
        ...state,
        item: action.payload
      }
    }

    case GET_ITEM: {
      return {
        ...state,
        isFetching: true,
        item: null
      }
    }

    case GET_ITEM_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        item: action.payload
      }
    }

    case GET_ITEM_FAILURE: {
      return {
        ...state,
        isFetching: false,
        item: null
      }
    }

    case MYPERMISSION_REQUETS: {
      return {
        ...state,
        permissionIsFetching: true,
        permissionRequest: false,
      }
    }

    case MYPERMISSION_REQUETS_SUCCESS: {
      return {
        ...state,
        permissionIsFetching: false,
        permissionRequest: true,
      }
    }

    case MYPERMISSION_REQUETS_FAILURE: {
      return {
        ...state,
        permissionIsFetching: false,
        permissionRequest: true,
      }
    }

    case GIVING_PERMISSION: {
      return {
        ...state,
        openDetail: action.payload
      }
    }
    case SET_IS_FETCHING_OBJECT_GROUPS: {
      return {
        ...state,
        isFetchingObjectGroups: true
      }
    }
    case UNSET_IS_FETCHING_OBJECT_GROUPS: {
      return {
        ...state,
        isFetchingObjectGroups: false
      }
    }
    case SET_IS_FETCHING_OBJECT_GROUPS_MODAL: {
      return {
        ...state,
        isFetchingObjectGroupsModal: true
      }
    }
    case UNSET_IS_FETCHING_OBJECT_GROUPS_MODAL: {
      return {
        ...state,
        isFetchingObjectGroupsModal: false
      }
    }
    default: return { ...state }
  }
}
